<script setup lang="ts">
import { computed } from 'vue'
import { useFleetStore } from '@/stores/fleetStore'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'

/**
 * Props
 */
const props = defineProps({
  fleetId: {
    type: Number,
    required: true
  }
})

/**
 * Stores
 */
const fleetStore = useFleetStore()

/**
 * Variables / Refs
 */
// Add your reactive variables here

/**
 * Computed
 */
const fleetData = computed(() => fleetStore.findFleetById(props.fleetId)!)

/**
 * Methods
 */
// Add your methods here

/**
 * Lifecycle hooks
 */
// Add lifecycle hooks if needed (onMounted, onUnmounted, etc.)
</script>

<template>
  <div>
    {{ fleetData.currentActionName }}
    <span
      v-if="fleetData.defendActionSet === 1 && fleetData.currentActionName !== 'Defend'"
      class="pl-1"
    >
      <GenericIcon type="shield" tooltip="Defend" />
    </span>
    <span v-if="fleetData.actions.length > 1" class="pl-1">
      {{ fleetData.actions.length > 1 ? '+' + (fleetData.actions.length - 1) : '' }}
    </span>
  </div>
</template>

<style scoped lang="scss">
// Add your component-specific styles here
</style>
